import { TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react'

import BBVALogo from '../../assets/images/logo-bbva.svg'
import { textFieldWhiteBg } from '../../theme/custom-styles'
import AVVillasLogo from '../../assets/images/logo-av-villas.svg'
import { handleGetParsedValue, numberWithCommas } from '../../utils'

export const UpdateBankBalanceForm = forwardRef(({ selectedBankName, handleActionButtonDisableState }: { selectedBankName: string; handleActionButtonDisableState: (disableState: boolean) => void }, ref) => {
  const { t } = useTranslation(['banks-balances-management'])

  const [balanceDataToDisplay, setBalanceDataToDisplay] = useState<string>('')
  const [currentBankBalanceData, setCurrentBankBalanceData] = useState<number>(0)

  useEffect(() => {
    const balanceToDisplay = 0

    setCurrentBankBalanceData(Number(balanceToDisplay))
    setBalanceDataToDisplay(`$ ${numberWithCommas(Number(balanceToDisplay))}`)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useImperativeHandle(
    ref,
    () => {
      return {
        balanceDataToDisplay
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [balanceDataToDisplay]
  )

  return (
    <div className="add-balance-to-client-form-container">
      <div className="add-balance-to-client-form-personal-data-container">
        <div className="add-balance-to-client-form-personal-data-square-container">
          <div className="add-balance-to-client-form-personal-data-info">
            <img
              src={selectedBankName === 'AVVillas' ? AVVillasLogo : BBVALogo}
              alt="bank-logo"
              style={{ minHeight: '50px' }}
            />
          </div>
        </div>
        <div className="add-balance-to-client-form-payment-data-container">
          <TextField
            fullWidth
            variant="standard"
            sx={textFieldWhiteBg}
            value={balanceDataToDisplay ?? ''}
            label={`${t('updateBankBalanceModal.formFields.currentAssignedBalance')} (COP)`}
            onBlur={(event) => {
              if (event.target.value === '') {
                setBalanceDataToDisplay(`$ ${numberWithCommas(currentBankBalanceData)}`)
              }
            }}
            onChange={(event) => {
              const extractedNumber = event.target.value[0] === '$' ? Number(event.target.value.slice(1).trim().replaceAll(',', '')) : Number(event.target.value.trim().replaceAll(',', ''))

              if (extractedNumber !== currentBankBalanceData) {
                handleActionButtonDisableState(false)
              } else {
                handleActionButtonDisableState(true)
              }

              if (isNaN(extractedNumber)) {
                return
              }

              if (event.target.value.trim() === '$' || event.target.value.trim() === '0') {
                return setBalanceDataToDisplay('')
              }

              const valueToSet = handleGetParsedValue(event)
              setBalanceDataToDisplay(valueToSet)
            }}
          />
        </div>
      </div>
    </div>
  )
})
